
import Vue from "vue";
import { UserInfo } from "@/models/dossier/user-info";
import { DossierService } from "@/services/dossier-service";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			users: [] as UserInfo[],
			value: [] as UserInfo[],
			items: [] as ISelectItem<UserInfo>[]
		};
	},
	props: {
		userInfoList: {
			type: Array as () => string[],
			required: true,
		}
	},
	methods: {
		updateItems() {
			this.items = this.users.map(a => {
				return {
					text: a.Firstname + " " + a.Lastname,
					value: a
				};
			});
		},
		updateValue() {
			for (let user of this.userInfoList) {
				let index = this.users.findIndex(a => a.ID.toString() == user);
				this.value.push(this.users[index]);
			}
		},
		async onInput(){
			let ids = this.value.map(u=>u.ID.toString());
			await this.$nextTick();
			this.$emit("update",ids);
		}
	},
	async created() {
		this.users = await DossierService.getUsers();
		this.updateItems();
		this.updateValue();
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
